import styled from 'styled-components';
import { SYS_SPACE_RELATIVE_MD } from '@oneaudi/unified-web-common';
import { Notification } from '@oneaudi/unified-web-components';
import { breakPoints } from '~/styles/break-points';

export const StyledNotificationContainer = styled.div`
	position: fixed;
	width: 100%;
	z-index: 10;
`;

export const StyledNotification = styled(Notification)`
	float: right;
	max-width: 400px;
	width: fit-content;
	position: relative;
	margin-top: ${SYS_SPACE_RELATIVE_MD};
	display: flex;

	${breakPoints({
		'768': `
			margin-top: 20px;
		`,
	})}
`;
